import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationModule } from './authentication/authentication.module';
import { RequestTypePipe } from './pipes/request-type/request-type.pipe';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AuthenticationModule
  ]
})
export class CoreModule { }
